import React from "react"
import { useBlocks } from "../../hooks/use-blocks"
import { parseISO, format } from "date-fns"
import { filterEvents as filteredEvents } from "./events"

export function Bandsintown({ id }) {
  const { properties } = useBlocks(id)
  const events = filteredEvents(
    properties.events,
    properties.startDate,
    properties.endDate
  )

  return (
    <div
      className="ck-bandsintown-block"
      style={{
        maxWidth: 800,
        margin: "0 auto"
      }}
    >
      <table
        cellPadding="0"
        cellSpacing="0"
        border="0"
        style={{
          width: "100%",
          borderCollapse: "collapse",
          padding: "0",
          margin: "0",
          tableLayout: "fixed"
        }}
      >
        <tbody style={{ color: properties.textColor }}>
          {events &&
            events.map((event, index) => {
              const time = new Date(event.event_timestamp)
              return (
                <tr
                  key={`${event.name}-${index}`}
                  style={{
                    borderBottom: "1px solid rgba(209, 213, 219, 0.35)",
                    marginTop: "8px"
                  }}
                >
                  <td
                    key={event.location}
                    style={{
                      width: "42px",
                      verticalAlign: "middle",
                      paddingTop: "4px",
                      paddingBottom: "4px",
                      wordWrap: "breakWord"
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "12px",
                        paddingLeft: "0.8px"
                      }}
                    >
                      {format(
                        parseISO(event.event_timestamp),
                        "MMM"
                      ).toUpperCase()}
                    </div>
                    <div
                      style={{
                        paddingLeft: "1px",
                        fontWeight: "600",
                        fontSize: "22px"
                      }}
                    >
                      {format(parseISO(event.event_timestamp), "dd")}
                    </div>
                  </td>
                  <td
                    style={{
                      verticalAlign: "middle",
                      paddingBottom: "10px",
                      paddingTop: "7px"
                    }}
                  >
                    <div
                      style={{
                        fontSize: "18px",
                        paddingBottom: "4px"
                      }}
                    >
                      {event.location === "Live Stream"
                        ? event.location
                        : event.name.length > 0
                        ? event.name
                        : properties.name}
                    </div>
                    {event.location === "Live Stream" ? (
                      <div
                        style={{
                          fontSize: "12px",
                          paddingTop: "2px",
                          paddingBottom: "0px"
                        }}
                      >
                        {time.toLocaleTimeString([], {
                          timeZoneName: "short",
                          hour12: "true",
                          hour: "numeric",
                          minute: "2-digit"
                        })}
                      </div>
                    ) : (
                      <div
                        style={{
                          fontSize: "12px",
                          paddingTop: "2px",
                          paddingBottom: "0px"
                        }}
                      >
                        {event.location}
                      </div>
                    )}
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    {!event.offer_url ? null : (
                      <div style={{ float: "right" }}>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={event.offer_url}
                          style={{
                            textDecoration: "none",
                            color: "inherit",
                            marginLeft: "auto",
                            padding: "8px 24px 8px 24px",
                            borderRadius: "4px",
                            border: "1px solid rgba(209, 213, 219, 0.35)",
                            background: "transparent",
                            height: "35px"
                          }}
                        >
                          {event.offer_type}
                        </a>
                      </div>
                    )}
                  </td>
                </tr>
              )
            })}
        </tbody>
      </table>
    </div>
  )
}
